<template>
  <el-dialog
    :close-on-click-modal="false"
    title="再入职"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        style="width: 500px"
      >
        <section slot="lastEntryDate" style="color:red;margin-bottom: 15px">
          <span>上次入职时间：{{originData.lastEntryDate}}</span>
        </section>
        <section slot="comment" style="color:red;margin-bottom: 15px">
          <span>备注：补录历史单，建议选用上次入职时间，避免影响司机工资。</span>
        </section>
        <section class="tip" slot="entryDateTip" style="margin-left: 10px;display: inline-block">
          <el-button type="primary" @click="toUseLastEntryDate">使用上次入职时间</el-button>
      </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  driverArchivesInAgain,
} from 'api/archives';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        levelConfigIdOptions: [],
        form: [
          {
            label: '上次入职时间',
            value: 'lastEntryDate',
            allCustom: true,
          },
          {
            label: '再入职时间',
            value: 'entryDate',
            type: 'date',
            placeholder: '请选择再入职时间',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '备注',
            value: 'comment',
            allCustom: true,
          },
          {
            label: '再入职原因',
            value: 'remark',
            type: 'input',
            placeholder: '请输入再入职原因，最多100字',
            attr: {
              type: 'textarea',
              maxlength: 100,
            },
          },
        ],
        rules: { // 表单验证规则
          entryDate: [ // 再入职时间
            { required: true, message: '请选择再入职时间', trigger: 'change' },
          ],
          remark: [ // 再入职原因
            { required: true, message: '请输入再入职原因', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      console.log('item', item);
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      if (item) { // 修改
        this.type = 'edit';
        this.originData = item;
        this.originData.lastEntryDate = item.entryDate;
      } else { // 新增
        this.type = 'add';
      }
    },
    toUseLastEntryDate () {
      this.$refs.customForm.setVal('entryDate', new Date(this.originData.lastEntryDate));
    },
    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await driverArchivesInAgain({
        userId: this.originData.userId,
        entryDate: this.formatDate(form.entryDate),
        remark: form.remark,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
